/**
 * Vietnamese strings keyed by code. Core and API return codes; the UI turns them
 * into text here (plan 3: `messages/vi.ts`).
 */
export const vi = {
  'home.title': 'Ôn Lái Xe',
  'home.drive': 'Lái tự do',
  'home.exam': 'Thi thử',
  'home.theory': 'Ôn lý thuyết',
  'drive.title': 'Lái tự do',
  'exam.title': 'Thi thử',
  'theory.title': 'Ôn lý thuyết',
  'onboarding.title': 'Làm quen',
  'history.title': 'Lịch sử',
  'auth.title': 'Đăng nhập',
  'auth.intro': 'Đăng nhập để lưu lịch sử thi và tiến độ ôn tập trên mọi thiết bị.',
  'auth.google': 'Tiếp tục với Google',
  'auth.google.pending': 'Đang chuyển tới Google…',
  'auth.or': 'hoặc nhận mã qua email',
  'auth.email.label': 'Email',
  'auth.email.submit': 'Gửi mã',
  'auth.email.pending': 'Đang gửi mã…',
  'auth.code.label': 'Mã xác nhận (6 số)',
  'auth.code.sentTo': 'Đã gửi mã 6 số tới',
  'auth.code.hint': 'Mã có hiệu lực 5 phút. Kiểm tra cả hộp thư rác.',
  'auth.code.submit': 'Đăng nhập',
  'auth.code.pending': 'Đang đăng nhập…',
  'auth.code.resend': 'Gửi lại mã',
  'auth.code.resent': 'Đã gửi mã mới.',
  'auth.code.changeEmail': 'Đổi email',
  'auth.signedIn': 'Bạn đã đăng nhập bằng',
  'auth.continue': 'Tiếp tục',
  'auth.error.invalidEmail': 'Email chưa đúng. Hãy nhập lại, ví dụ ten@gmail.com.',
  'auth.error.codeFormat': 'Mã gồm đúng 6 chữ số.',
  'auth.error.invalidCode': 'Mã không đúng. Hãy kiểm tra lại 6 số trong email.',
  'auth.error.expiredCode': 'Mã đã hết hạn. Hãy bấm "Gửi lại mã" để nhận mã mới.',
  'auth.error.tooManyAttempts': 'Nhập sai quá nhiều lần. Hãy bấm "Gửi lại mã" để nhận mã mới.',
  'auth.error.rateLimited': 'Bạn yêu cầu mã quá nhiều lần. Vui lòng đợi một phút rồi thử lại.',
  'auth.error.delivery': 'Không gửi được mã. Hãy thử Google hoặc thử lại sau.',
  'auth.error.banned': 'Tài khoản này đã bị khoá.',
  'auth.error.network': 'Không kết nối được. Hãy kiểm tra mạng rồi thử lại.',
  'auth.error.google': 'Không đăng nhập được bằng Google. Hãy thử lại hoặc nhận mã qua email.',
  'auth.error.generic': 'Không đăng nhập được. Vui lòng thử lại.',
  'auth.error.signOut': 'Không đăng xuất được. Vui lòng thử lại.',
  'history.save.saving': 'Đang lưu vào lịch sử…',
  'history.save.pending': 'Sẽ lưu khi có mạng',
  'history.save.saved': 'Đã lưu vào lịch sử',
  'history.save.failed': 'Không lưu được kết quả này vào lịch sử.',
  'history.save.guestInvite': 'Đăng nhập để lưu kết quả các lần thi sau vào lịch sử.',
  'history.save.guestAction': 'Đăng nhập',
  'history.heading': 'Lịch sử thi',
  'history.signedOut.title': 'Đăng nhập để xem lịch sử',
  'history.signedOut.text':
    'Lịch sử các lượt thi được lưu theo tài khoản, nên xem lại được trên mọi thiết bị. Bạn vẫn thi thử bình thường khi chưa đăng nhập.',
  'history.signedOut.action': 'Đăng nhập',
  'history.filter.label': 'Lọc lượt thi',
  'history.filter.kind': 'Loại',
  'history.filter.class': 'Hạng',
  'history.filter.all': 'Tất cả',
  'history.filter.clear': 'Bỏ bộ lọc',
  'history.kind.theory': 'Lý thuyết',
  'history.kind.sim': 'Sa hình',
  'history.passed': 'Đạt',
  'history.failed': 'Không đạt',
  'history.fail.CRITICAL_WRONG': 'Sai câu điểm liệt',
  'history.fail.BELOW_PASS': 'Chưa đủ điểm đạt',
  'history.fail.label': 'Lý do',
  'history.list.label': 'Các lượt thi, mới nhất trước',
  'history.loadMore': 'Xem thêm',
  'history.loadingMore': 'Đang tải thêm…',
  'history.loadMoreFailed': 'Không tải thêm được. Hãy thử lại.',
  'history.empty.title': 'Chưa có lượt thi nào',
  'history.empty.text':
    'Làm một bài thi thử khi đã đăng nhập, kết quả sẽ tự lưu vào đây để bạn xem lại câu sai và lỗi đã mắc.',
  'history.empty.theory': 'Thi thử lý thuyết',
  'history.empty.sim': 'Thi thử sa hình',
  'history.emptyFiltered.text':
    'Không có lượt thi nào khớp bộ lọc này. Hãy chọn loại hoặc hạng khác.',
  'history.error.network': 'Không kết nối được. Hãy kiểm tra mạng rồi thử lại.',
  'history.error.server': 'Lịch sử tạm thời không tải được. Vui lòng thử lại sau ít phút.',
  'history.error.generic': 'Không tải được lịch sử. Vui lòng thử lại.',
  'history.retry': 'Thử lại',
  'history.detail.heading': 'Chi tiết lượt thi',
  'history.detail.back': 'Về lịch sử',
  'history.detail.score': 'Điểm',
  'history.detail.passScore': 'Điểm đạt',
  'history.detail.regulation': 'Bộ quy định',
  'history.detail.contentVersion': 'Phiên bản nội dung',
  'history.detail.duration': 'Thời gian làm bài',
  'history.detail.wrong': 'Câu trả lời sai',
  'history.detail.wrongNone': 'Không sai câu nào.',
  'history.detail.critical': 'điểm liệt',
  'history.detail.penalties': 'Lỗi đã mắc',
  'history.detail.penaltiesNone': 'Không mắc lỗi nào.',
  'history.detail.noDetails': 'Lượt thi này không có thông tin chi tiết.',
  'history.detail.retakeTheory': 'Làm lại đúng đề này',
  'history.detail.practiceTheory': 'Ôn theo chương',
  'history.detail.retrySim': 'Thi lại sa hình',
  'history.detail.notFound':
    'Không tìm thấy lượt thi này. Có thể nó đã bị xoá hoặc thuộc tài khoản khác.',
  'history.detail.loading': 'Đang tải chi tiết…',
  'header.brand': 'Ôn Lái Xe',
  'header.signIn': 'Đăng nhập',
  'header.signOut': 'Đăng xuất',
  'header.signingOut': 'Đang đăng xuất…',
  'header.account': 'Tài khoản',
  'header.history': 'Lịch sử',
  'header.accountLink': 'Tài khoản',
  'layout.skipToMain': 'Bỏ qua, tới nội dung chính',
  'nav.main': 'Điều hướng chính',
  'nav.tabbar': 'Mục chính',
  'nav.home': 'Trang chủ',
  'nav.theory': 'Lý thuyết',
  'nav.exam': 'Thi thử',
  'nav.practice': 'Sa hình 3D',
  'nav.me': 'Tôi',
  'examHub.title': 'Thi thử',
  'examHub.lead': 'Đề lý thuyết theo hạng và bài thi sa hình 3D, chấm như khi thi thật.',
  'practiceHub.title': 'Sa hình 3D',
  'practiceHub.lead': 'Lái tự do, luyện từng bài thi sa hình và làm quen với điều khiển.',
  'me.title': 'Tôi',
  'me.lead': 'Tài khoản, lịch sử thi và cài đặt của bạn.',
  'me.appearance': 'Giao diện',
  'account.title': 'Tài khoản',
  'account.email': 'Email đăng nhập',
  'account.history': 'Xem lịch sử thi',
  'account.signedOut.title': 'Đăng nhập để quản lý tài khoản',
  'account.signedOut.text':
    'Tại đây bạn xem email đăng nhập và có thể xoá tài khoản cùng toàn bộ dữ liệu của mình.',
  'account.signedOut.action': 'Đăng nhập',
  'account.delete.heading': 'Xoá tài khoản',
  'account.delete.intro':
    'Bạn có thể xoá tài khoản và mọi dữ liệu gắn với nó bất cứ lúc nào, không cần nêu lý do.',
  'account.delete.start': 'Xoá tài khoản',
  'account.delete.explainTitle': 'Những gì sẽ bị xoá',
  'account.delete.what.account': 'Email, tên hiển thị và liên kết đăng nhập Google của tài khoản.',
  'account.delete.what.history': 'Toàn bộ lịch sử thi lý thuyết và sa hình.',
  'account.delete.what.progress': 'Tiến độ ôn tập đã đồng bộ, kể cả danh sách câu sai.',
  'account.delete.what.sessions': 'Mọi phiên đăng nhập, trên mọi thiết bị.',
  'account.delete.what.device':
    'Kết quả đang chờ lưu và tiến độ của tài khoản trên trình duyệt này. Trên thiết bị khác, dữ liệu lưu tạm trong trình duyệt tự xoá khi mở lại ứng dụng ở đó, chậm nhất sau 7 ngày.',
  'account.delete.irreversible':
    'Việc xoá không thể hoàn tác. Dữ liệu đã xoá có thể còn trong bản sao lưu tối đa khoảng 30 ngày rồi tự bị ghi đè.',
  'account.delete.continue': 'Tiếp tục',
  'account.delete.cancel': 'Huỷ',
  'account.delete.confirmTitle': 'Xác nhận xoá tài khoản',
  'account.delete.confirmLabel': 'Nhập email của bạn để xác nhận',
  'account.delete.confirmHint': 'Gõ đúng địa chỉ:',
  'account.delete.submit': 'Xoá vĩnh viễn',
  'account.delete.pending': 'Đang xoá tài khoản…',
  'account.delete.mismatch': 'Email chưa khớp với tài khoản đang đăng nhập.',
  'account.delete.reauth':
    'Vì an toàn, cần đăng nhập lại trước khi xoá (lần đăng nhập gần nhất đã hơn 24 giờ). Tài khoản chưa bị xoá.',
  'account.delete.reauthAction': 'Đăng nhập lại',
  'account.delete.lastAdmin':
    'Đây là tài khoản quản trị cuối cùng. Hãy cấp quyền quản trị cho người khác trước khi xoá.',
  'account.delete.network':
    'Không kết nối được. Hãy kiểm tra mạng rồi thử lại. Tài khoản chưa bị xoá.',
  'account.delete.generic': 'Không xoá được tài khoản. Vui lòng thử lại.',
  'account.deleted': 'Tài khoản và dữ liệu của bạn đã được xoá.',
  'common.back': 'Về trang chủ',
  'common.loading': 'Đang tải…',
  'common.comingSoon': 'Tính năng đang được xây dựng.',
  'error.generic': 'Đã có lỗi xảy ra. Vui lòng tải lại trang.',
  'error.reload': 'Tải lại',
  'error.notFound': 'Không tìm thấy trang này.',
} as const satisfies Record<string, string>;

export type MessageCode = keyof typeof vi;

/** Look up the Vietnamese text for a message code. */
export function t(code: MessageCode): string {
  return vi[code];
}
